import { SVGProps, Ref, forwardRef } from 'react';

export const VerifiedBadgeFilledSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.417 4.106c-.084.193-.332.409-.573.614C.446 5.065 0 5.458 0 6s.446.935.844 1.28c.241.205.489.42.573.614.086.2.068.521.05.837-.027.504-.094 1.11.294 1.505.38.38.968.328 1.46.3.33-.017.668-.041.88.049.192.078.416.331.62.572.344.397.736.843 1.279.843.554 0 .944-.462 1.278-.843.211-.24.429-.488.622-.572.21-.09.554-.066.88-.048.488.027 1.083.08 1.46-.301.394-.395.32-1 .292-1.507-.018-.315-.035-.63.05-.83.08-.192.333-.415.574-.62C11.554 6.936 12 6.542 12 6s-.446-.936-.844-1.28c-.241-.204-.495-.427-.573-.62-.086-.2-.069-.514-.051-.829.028-.506.102-1.112-.293-1.507-.376-.382-.97-.328-1.46-.3-.325.017-.668.041-.88-.049-.192-.084-.41-.331-.62-.572C6.943.463 6.552 0 6 0c-.543 0-.935.446-1.278.843-.205.24-.429.494-.621.572-.212.09-.55.066-.88.048-.538-.03-1.092-.066-1.46.301-.373.378-.324.952-.293 1.505.017.316.035.637-.05.837m3.833 4.03L8.886 4.5l-.636-.636-3 3-1.5-1.5L3.114 6z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
VerifiedBadgeFilledSize12Glyph.displayName = 'VerifiedBadgeFilledSize12Glyph';
